// extracted by mini-css-extract-plugin
export default {"labelWithLoadingSpinner":"useEmailSendVariants_labelWithLoadingSpinner__L7aRC","loadingSpinner":"useEmailSendVariants_loadingSpinner__F4Pnh"};